export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14707.d186b764.jpg";